<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Reporte Diario de Ingresos"
          :icon="'dollar-sign'"
        />
      </div>
    </div>

    <income-modal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      @close-modal="closeAddEditModal"
    />

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <h5 class="card-title m-0">Beneficiario: Servicio de Acreditación Ecuatoriano – SAE</h5>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
            <button class="btn btn-primary" v-on:click="reloadTables()"> <i data-feather="refresh-ccw" class="pr-2"/> Refrescar</button>
        </div>
      </div>
    </div>
    <br>

    <app-table :id="tableId" :options="options" @action="getListAction" />

  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../../apiUrl";
import { IncomeTableHelpers } from "./IncomeTableHelpers";


export default {
  extends: CoreLibrary,
  name: "IndexIncome",
  mixins: [IncomeTableHelpers],
  data() {
    return {
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      // selectedUrl: "",
      tableId: "income-list",
      rowData: {},
      options: {
        url: `${actions.TREASURY_INCOME}/index`,
        name: this.$t("demo_crud"),
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("Ver"),
            icon: "eye",
            type: "none",
            component: "income-modal",
            modalId: "income-add-edit-modal",
          },
        ],
        filters: [
          {
              "title": 'Tipo',
              "type": "checkbox",
              "key": "type",
              "option": [
                  {id: 'S', value: 'Solicitud'},
                  {id: 'P', value: 'Proforma'}
              ],
          },
          {
              "title": 'Bancos',
              "type": "drop-down-filter",
              "key": "bank",
              "option": [],
          },
          {
              "title": 'Tipo de Transacción',
              "type": "drop-down-filter",
              "key": "trasaction",
              "option": [],
          }
        ],
        showFilter: true,
        showSearch: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default"
      },
    };
  },
  created() {
    this.options.columns = [...this.tableColumns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  methods: {
    reloadTables(){
      this.$hub.$emit("reload-" + this.tableId);
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#income-add-edit-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.searchAndSelectFilterOptions();
      this.reSetData();
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      window.location = `${actions.TREASURY}/showInfo/${rowData.id}`;
      // this.openAddEditModal();
    },
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      let url = `${actions.TREASURY_INCOME}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#pending-delete").modal("hide");
          this.cancelled();
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          //trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      // this.selectedUrl = "";
    },

    searchAndSelectFilterOptions(){
      let url = `${actions.TREASURY_CORRECTIONS}/options`;
      this.axiosGet(url).then(response => {
        let amountFilter = this.options.filters.find(element => element.title === 'Monto');
        if(!amountFilter){
          this.options.filters.push({
            "title": 'Monto',
            "type": "range-filter",
            "key": "amount-range",
            "maxTitle": 'Minimo',
            "minTitle": 'Maximo',
            "sign": "USD",
            "maxRange": Number(response.data.max),
            "minRange": Number(response.data.min)
          });
        }
        let name = this.options.filters.find(element => element.title === 'Bancos');
        name.option = response.data.bank.map(name => {
            return {
                id:name.id,
                value:name.value
            }
        });
        let transaction = this.options.filters.find(element => element.title === 'Tipo de Transacción');
        transaction.option = response.data.transactiontype.map(transaction => {
            return {
                id:transaction.id,
                value:transaction.value
            }
        });
      });
    }
  },
};
</script>
